export default {
    getSearchFilter: state => state.searchFilter,
    mode: state => state.mode,
}